/* eslint-disable max-len */

export const caymanInvestmentStatements = [
  'AV is purchasing shares directly issued by the Company through a 3rd party vehicle',
  'AV is purchasing shares as part of a secondary transaction (not directly from the Company)',
];

export const investmentStatementQuestion = {
  label: 'Please indicate which of the following statements apply to this investment:',
  value: [],
  options: [
    'AV is purchasing shares directly issued by the Company',
    ...caymanInvestmentStatements,
  ],
};

export const questionList = [
  {
    name: 'sameRoundAsPriorInvestment',
    label: `Should this investment be considered the same round/deal as a prior AV investment?
    (e.g., a planned 2nd tranche or 2nd wire for an existing investment,
    execution of warrants/options secured as part of a prior investment, etc.)`,
    value: null,
  },
];

export default questionList;
